export default __webpack_public_path__ + "static/media/be-certain.78b4994c.svg";